import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end mt-3 mb-5 fs-14 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumToSelectButton = _resolveComponent("EnumToSelectButton")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_EnumToSelectButton, {
      modelValue: _ctx.actionToAdd.dimmerStatus,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionToAdd.dimmerStatus = $event)),
      class: "mb-5",
      enum: _ctx.DimmerStatus
    }, null, 8, ["modelValue", "enum"]),
    _createVNode(_component_Slider, {
      disabled: _ctx.actionToAdd.dimmerStatus !== _ctx.DimmerStatus.Dimmer,
      modelValue: _ctx.actionToAdd.dimmerPercentage,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionToAdd.dimmerPercentage = $event)),
      min: 1,
      max: 100,
      step: 1
    }, null, 8, ["disabled", "modelValue"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("span", null, _toDisplayString(_ctx.actionToAdd.dimmerPercentage), 1)
    ])
  ], 64))
}